import { SessionDetails } from "./Types";

export async function getSession(roomId: string,code:string) {
    const resp = await fetch('/.proxy/api/connect/'+roomId,{
        headers: {
            "Authorization": `${code}`
        }
    });
    if (!resp.ok) {
        throw new Error(`Failed to fetch session: ${resp.statusText}`);
    }
    const data = (await resp.json()) as SessionDetails;
    return data;
}